export default __webpack_public_path__ + "static/media/Warmonger's Battlebow.9085ac18.jpg";